import xtend from 'xtend';
import _ from 'underscore';
import Model from 'pull-stream-model';
import shouldUpdate from 'pull-stream-model/should-update';
import ReactStream from '@invintus/react-pull-stream';
import EditView from '../../vast/edit/view/VastEdit';
import VastModel from '../../vast/edit/model/index';
import queryString from '../../utils/QueryString';
import S from '../../lib/pull-stream';
// import Log from '../../lib/log';

var r = {};
r.path = require('ramda/src/path');

// function isDev () {
//     return process.env.NODE_ENV === 'development';
// }

function VastEditRoute (api, socket, opts, match) {
    var vastModel = Model(VastModel(api));

    // @TODO client side routing will pass in the query string
    var qsParams = queryString.parse(window.location.search);
    var vastID = qsParams.id;

    var viewStream = ReactStream(EditView);

    // @TODO nicer api for this
    // viewStream.source.push is an implementation detail. We should have a
    // method or something on the model, or a separate stream...
    // could have `createWriteStream` on the model. Which would proxy
    // pull-many
    if (vastID) {
        viewStream.source.push(vastModel.msg.vast.get({
            campaignID: vastID
        }));
    }

    viewStream.source.push(vastModel.msg.events.get(VastModel.DEFAULT_QUERY));
    viewStream.source.push(vastModel.msg.categories.get());
    viewStream.source.push(vastModel.msg.assets.getMiscAssets());
    viewStream.source.push(vastModel.msg.vastList.get());

    var getDomain = r.path([0]);
    var getAction = r.path([1, 0]);

    // var log = Log();

    S(
        viewStream.source,
        vastModel.effects(),

        // S.through(function (ev) {
        //     if (!isDev()) return;
        //     log.push(ev);
        // }),

        // @FIXME
        S.through(function (ev) {
            if (getDomain(ev) === 'vast' && getAction(ev) === 'add') {
                // successful create request
                queryString.set({ id: ev[1][1].campaignID });
            }
        }),

        vastModel.store,

        S.map(function (state) {
            return xtend(state, {
                events: xtend(state.events, {
                    data: _.toArray(state.events.data)
                }),
                assets: xtend(state.assets, {
                    data: _.toArray(state.assets.data)
                })
            });
        }),

        shouldUpdate(function (prev, next) {
            if (!prev) return true;
            return !(prev.vast.resolving.length > 0 &&
                next.vast.resolving.length > 0)
            ;
        }),

        // S.through(console.log.bind(console, 'state')),
        viewStream.sink
    );

    return viewStream.view;
}

export default VastEditRoute;
